import { DreamBlock } from '@typedream/core';
import { isBlock, TNodeEntry } from '@udecode/plate-core';
import {
  isLinkableElement,
  isPathRoot,
  isTextBlock,
} from '../../editorTools/queries';
import { ElementPluginOptions, getTElementPlugins } from '../../plate';
import {
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_PARAGRAPH,
} from '../../pluginKeys';
import { DreamEditor } from '../../types';

export function getAllBlockTypeOptions(editor: DreamEditor) {
  return getTElementPlugins(editor)
    .filter((p) => p.isElement && p.options?.isDreamBlock)
    .map((p) => ({
      type: p.type as DreamBlock['type'],
      title: (p.options as ElementPluginOptions).meta?.title,
    }));
}

export function shouldShowSizing(elementEntry: TNodeEntry<DreamBlock>) {
  const [element, path] = elementEntry;

  return (
    element.type !== 'img'
    && element.type !== 'media_embed'
    && element.type !== 'spacer'
    && (isPathRoot(path)
      || (element.type === 'li' && isPathRoot(path.slice(0, 1))))
  );
}

export function shouldShowLink(
  editor: DreamEditor,
  elementEntry: TNodeEntry<DreamBlock>,
) {
  const [element] = elementEntry;
  return isLinkableElement(element) || isTextBlock(editor, element);
}

export function shouldShowLeafAnimation(
  editor: DreamEditor,
  elementEntry: TNodeEntry<DreamBlock>,
) {
  const [element] = elementEntry;
  return (
    isBlock(editor, element)
    && [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3].includes(
      element.type,
    )
  );
}
